module.exports = __webpack_public_path__ + "img/favicon-32x32.5aab2e3.png";